import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';

import storage from 'redux-persist/lib/storage';

import generalReducer from './reducers/general';
import modalsReducer from './reducers/modals';

import { api } from '../services/api';
import { CLEAR_STORE } from './actions/general';

const persistConfig = {
  key: 'root',
  storage,
};

const reducer = combineReducers({
  [api.reducerPath]: api.reducer,
  general: generalReducer,
  modals: modalsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === CLEAR_STORE) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleware = [api.middleware];

if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');
  middleware.push(logger);
}

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middleware),
});

export const persistor = persistStore(store);
